export default __webpack_public_path__ + "static/media/logo192.f756ea24.png";